import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField
} from 'react-admin';

// own ui
import CustomFilterTextActive from '../../ui/custom-filter-text-active';
import CustomImageField from '../../ui/custom-image-field';
import WayExporter from '../../exporter/way-exporter';
import { ColorField } from 'react-admin-color-input';

const WayList = (props) => (
    <List
      title="Caminhos" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterTextActive /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ WayExporter } >
        <Datagrid
          rowClick="show">
          <TextField source="id" sortable={true} />
          <CustomImageField source="image_cover" label="Imagem" sortable={false}/>
          <TextField source="name.pt_br" label="Nome" sortable={false} />
          <TextField source="city_departure.name" label="Cidade de Partida" sortable={false} />
          <TextField source="city_arrival.name" label="Cidade de Chegada" sortable={false} />
          <ColorField source="color_base" label="Cor Base" sortable={false}/>
          <ColorField source="secondary_color" label="Cor Secundária" sortable={false}/>
          <BooleanField source="active" label="Ativo" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default WayList;
